import themeTokens from './theme-tokens';
import theme from './current-theme';
export default themeTokens[theme];